// The agency's /finance reads beside its tabs (finance redesign slice 3): the team, the business expenses and the agency's
// cash; To do, Clients and Cash read on jobs through useAgencyTabs (finance consolidation S9). The keys extend
// financeKeys, so every finance mutation refreshes them.
import { useQuery } from "@tanstack/react-query";
import { agencyService } from "../services/agencyService";
import type { AgencyCashInput } from "../types";
import { financeKeys, useFinanceMutation } from "./financeQuery";

export const agencyKeys = {
  team: () => [...financeKeys.all, "agency", "team"] as const,
  expenses: () => [...financeKeys.all, "agency", "expenses"] as const,
  agencyCash: () => [...financeKeys.all, "agency-cash"] as const,
};

export const useAgencyTeam = () => useQuery({ queryKey: agencyKeys.team(), queryFn: agencyService.team });

/** `enabled` false on the page's other tabs: only the ads drawer reads it there, from the cache its tab filled. */
export const useAgencyExpenses = (enabled = true) => useQuery({ queryKey: agencyKeys.expenses(), queryFn: agencyService.expenses, enabled });

/** The agency's cash on a date (J18): Setup's card and its drawer. */
export const useAgencyCashFigure = () => useQuery({ queryKey: agencyKeys.agencyCash(), queryFn: agencyService.agencyCash });

/** Replaces the agency's cash. Every finance read refetches after it, Cash included. */
export const useSaveAgencyCash = () => useFinanceMutation((input: AgencyCashInput) => agencyService.setAgencyCash(input), () => "Agency cash saved");
